
function waitForVariantSelects(maxWait = 3000) {
  const intervalTime = 100;
  let waited = 0;

  const interval = setInterval(() => {
    const selects = document.querySelectorAll('.product-variant-select');

    if (selects.length > 0) {
      clearInterval(interval);
      console.log('✅ Found variant selects after wait');
      attachPriceUpdater(selects);
    }

    waited += intervalTime;
    if (waited >= maxWait) {
      clearInterval(interval);
      console.warn('❌ Timeout: No variant selects found after waiting');
    }
  }, intervalTime);
}

function attachPriceUpdater(selects) {
  console.log('✅ Attaching price updater');
  selects.forEach((select) => {
    select.addEventListener('change', () => {
      const selected = select.options[select.selectedIndex];
      const card = select.closest('.card__content');
      if (!card) return;

      const price = selected.getAttribute('data-price');
      const compare = selected.getAttribute('data-compare');

      const saleMoney = card.querySelector('.price__sale .price-item--sale .money');
      const compareMoney = card.querySelector('.price__sale s.price-item--regular .money');

      if (saleMoney && price) {
        saleMoney.textContent = `$${parseFloat(price).toFixed(2)}`;
      }

      if (compareMoney) {
        if (compare && compare !== price) {
          compareMoney.textContent = `$${parseFloat(compare).toFixed(2)}`;
          compareMoney.closest('s').style.display = 'inline';
        } else {
          compareMoney.closest('s').style.display = 'none';
        }
      }

      console.log('💰 Price updated:', price, compare);
    });
  });
}

document.addEventListener('DOMContentLoaded', () => {
  console.log('🔍 Waiting for variant selects...');
  waitForVariantSelects();
});
document.addEventListener('shopify:section:load', () => {
  console.log('🔄 Section loaded. Waiting for variant selects...');
  waitForVariantSelects();
});
